import instance from "../root.api";

export const questionExpertRequest = (data) =>
    instance.post(`/expert-questions`, data).then((response) => ({response}));
